import { render } from "./app-loader.vue?vue&type=template&id=5e823b00&scoped=true&ts=true"
import script from "./app-loader.vue?vue&type=script&lang=ts"
export * from "./app-loader.vue?vue&type=script&lang=ts"

import "./app-loader.vue?vue&type=style&index=0&id=5e823b00&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e823b00"]])

export default __exports__